export async function DetectPegasoDriver(PortaTcpTracerNew) {
    const httpUrl  = "http://127.0.0.1:" + PortaTcpTracerNew;
    const httpsUrl = "https://localhost:" + (PortaTcpTracerNew + 1);
    try {
        const controller = new AbortController();
        const timeout = setTimeout(() => controller.abort(), 800);
        const response = await fetch(httpsUrl + "/get-faketracer", {
            method: "GET",
            signal: controller.signal
        });
        clearTimeout(timeout);
        if (response.ok) {
            console.log("HTTPS detected:", httpsUrl);
            return httpsUrl;
        }
    } catch (err) {
        console.log("HTTPS not available.");
    }
    console.log("HTTP detected:", httpUrl);
    return httpUrl;
}
